import { AirplaneSearchIcon } from './AirplaneSearchIcon';

/**
 * author: Colton Wiscombe
 * id 4DBDF7D5-FD3A-4CE2-BCC6-306A09694221
 * name airplane-search
 * version: 6.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/airplane-search.svg
 * tags
 * - Transportation + Flying 
 */
export const AirplaneFindIcon = AirplaneSearchIcon;
export default AirplaneFindIcon